//LOCAL STORAGE
export const LS_profile = "profile";
export const LS_config = "config";

//QUERY PARAMS
export const QP_ID = "id";
export const QP_TOKEN = "token";

//ROUTES
export const R_HOME = "/";
export const R_PACIENTES = "/pacientes";
export const R_PACIENTE = "/paciente";
export const R_NUEVOPACIENTE = "/nuevoPaciente";
export const R_FIRMARCI = "/firmarCI";
export const R_TUTORLEGAL = "/tutorLegal";
export const R_HISTORIACLINICA = "/historiaClinica";
export const R_AGENDA = "/agenda";
export const R_ACTIVIDADES = "/actividades";
export const R_CITA = "/cita";
export const R_RESETPASS = "/resetPass";
export const R_CONFIG = "/config";
export const R_FACTURACION = "/facturacion";
export const R_SUSCRIPCION = "/suscripcion";
export const R_CREATEPASS = "/createPass";
export const R_WHATSAPP = "/whatsapp";
export const R_JORNADA = "/jornada";

export const timeRedirect = 3000;
//export const autoHideDuration = 5000;
export const locale = "es-ES";
export const momentLocale = "es";
export const defaultProvincia = "RI";
export const defaultEmpleadoColor = "rgb(153, 81, 42)";
export const defaultGridLength = 4;
//export const defaultNextCitasLength = 3;
export const googleAPI_postalCode = "postal_code";
export const colorFestivos = "#800000";
export const colorBackgroundFestivos = "rgba(128,0,0,0.2)";
export const colorNoDisponible = "rgba(0,0,0,0.75)";
// Franjas fuera del horario del profesional en la Agenda (registro de jornada): gris muy claro, distinto de los festivos
export const colorFueraHorario = "rgba(0,0,0,0.06)";
export const rowsPerPage = 8;

export const DNI_REGEX = /^(\d{8})([A-Z])$/;
export const NIE_REGEX = /^[XYZ]\d{7}[A-Z]$/;
export const CIF_REGEX = /^([ABCDEFGHJNPQRSUVW])(\d{7})([0-9A-J])$/;
export const Pasaporte_REGEX = /^[A-Z0-9<]{6,20}$/;
export const Email_REGEX = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
// Identificador fiscal genérico para países sin validación de formato específica (fuera de España):
// solo exige longitud razonable, permitiendo letras, números y guiones (cubre p.ej. Cédula/RUC de Panamá).
export const TAX_ID_GENERICO_REGEX = /^[A-Z0-9-]{5,20}$/i;
// Código postal genérico para países fuera de España: los formatos varían mucho (numéricos,
// alfanuméricos, con o sin espacio/guión), así que solo se exige una longitud razonable.
export const CODIGO_POSTAL_GENERICO_REGEX = /^[A-Z0-9\s-]{3,10}$/i;

export enum ROLES {
    ADMINISTRADOR = 0,
    SANITARIO = 1,
    SECRETARIO = 2
};

export const paises = [
    {id: 'ES', name: 'España', nifLabel: 'DNI, NIE o CIF', personNifLabel: 'DNI o NIE'},
    {id: 'PA', name: 'Panamá', nifLabel: 'RUC o Cédula', personNifLabel: 'Cédula'}
];

export const provincias = [
    {id: 'AN', name: 'Andalucía'},
    {id: 'AR', name: 'Aragón'},
    {id: 'AS', name: 'Asturias'},
    {id: 'CB', name: 'Cantabria'},
    {id: 'CE', name: 'Ciudad de Ceuta'},
    {id: 'CL', name: 'Castilla y León'},
    {id: 'CM', name: 'Castilla La Mancha'},
    {id: 'CN', name: 'Islas Canarias'},
    {id: 'CT', name: 'Cataluña'},
    {id: 'EX', name: 'Extremadura'},
    {id: 'GA', name: 'Galicia'},
    {id: 'IB', name: 'Islas Baleares'},
    {id: 'MC', name: 'Murcia'},
    {id: 'MD', name: 'Madrid'},
    {id: 'ML', name: 'Melilla'},
    {id: 'NC', name: 'Navarra'},
    {id: 'PV', name: 'País Vasco'},
    {id: 'RI', name: 'La Rioja'},
    {id: 'VC', name: 'Comunidad Valenciana'}
];

export const repetir = ["Nunca", "Todos los días", "Todas las semanas", "Cada 2 semanas", "Todos los meses"]; //, "Personalizado"
export const horarioClases = ["Mañana y tarde", "Mañana", "Tarde"];
export const monthNames = ["enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre"];
export const weekNames = ["Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado", "Domingo"];
export const duracion = [90, 60, 45, 30, 20, 15];
export const capacidad = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 15, 20, 25];
export const sexos = ["Hombre", "Mujer"];
export const formaConocer = ["Otra persona", "Internet", "Redes", "Cercanía", "Medios impresos"];
export const icons = ["Agua", "Diamante", "Montaña", "Planta", "Nieve"];

// 1, 2, 3, 4, 48, 49: códigos oficiales de la AEAT (futura integración Verifactu) — no tocar,
// solo aplican a España. 99 en adelante: códigos internos de la app para medios de pago
// específicos de otros países, sin ningún significado oficial ante ninguna administración —
// se mantienen deliberadamente alejados del rango de la AEAT para no mezclarlos.
export enum MetodoPagoCodigo {
    Efectivo = 1,
    Transferencia = 2,
    Cheque = 3,
    Otro = 4,
    Tarjeta = 48,
    Bizum = 49,
    Yappy = 99,
};

const METODOS_PAGO_UNIVERSALES = [
    { nombre: "Efectivo", codigo: MetodoPagoCodigo.Efectivo },
    { nombre: "Tarjeta", codigo: MetodoPagoCodigo.Tarjeta },
    { nombre: "Transferencia", codigo: MetodoPagoCodigo.Transferencia },
];

// Medios de pago específicos de un país, además de los universales.
const METODOS_PAGO_POR_PAIS: Record<string, { nombre: string; codigo: MetodoPagoCodigo }[]> = {
    ES: [{ nombre: "Bizum", codigo: MetodoPagoCodigo.Bizum }],
    PA: [{ nombre: "Yappy", codigo: MetodoPagoCodigo.Yappy }],
};

export const getMetodosPagoDisponibles = (pais: string) => [
    ...METODOS_PAGO_UNIVERSALES,
    ...(METODOS_PAGO_POR_PAIS[pais] || []),
];

export const IMPUESTOS = [0, 4, 10, 21];

export const SUPPORTED_CURRENCIES = [
  { code: "EUR", label: "Euro (€)", symbol: "€" },
  { code: "USD", label: "Dólar estadounidense ($)", symbol: "$" },
  { code: "MXN", label: "Peso mexicano (MX$)", symbol: "MX$" },
  { code: "COP", label: "Peso colombiano (COL$)", symbol: "COL$" },
] as const;

export type SupportedCurrency = typeof SUPPORTED_CURRENCIES[number]["code"];